/**
 * Fetches the two recommendation fragments (bundle + related) from Shopify's
 * native recommendations endpoint and wires up the bundle's live total +
 * "Add Selected to Cart" (sequential fetch('/cart/add.js') calls — same
 * pattern used everywhere else in this theme).
 */
(function () {
  'use strict';

  function fetchFragment(container) {
    var url = container.getAttribute('data-fetch-url');
    if (!url) return Promise.resolve();

    return fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        container.innerHTML = doc.body.innerHTML;
        // Newly-injected .pcc/.pcs cards need their sample-toggle / variant-chip
        // listeners wired up — product-card-variants.js only ran on page load.
        if (window.fixplusInitProductCards) window.fixplusInitProductCards(container);
      })
      .catch(function (error) {
        console.error('[fixplus] recommendation fetch failed:', error);
      });
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function initBundle(root) {
    var bundleFragment = root.querySelector('[data-role="bundle-fragment"]');
    if (!bundleFragment) return;

    var mainPriceEl = root.querySelector('[data-role="bundle-main-price"]');
    var mainPrice = mainPriceEl ? parseMoneyToCents(mainPriceEl.textContent) : 0;

    function parseMoneyToCents(text) {
      var num = parseFloat((text || '').replace(/[^0-9.]/g, ''));
      return Math.round((num || 0) * 100);
    }

    function recalc() {
      var total = mainPrice;
      var count = 1;
      root.querySelectorAll('.pcb__check').forEach(function (cb) {
        if (cb.checked) {
          total += parseInt(cb.getAttribute('data-price'), 10) || 0;
          count++;
        }
      });
      var totalEl = root.querySelector('[data-role="bundle-total"]');
      var countEl = root.querySelector('[data-role="bundle-count"]');
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (countEl) countEl.textContent = count + (count === 1 ? ' item selected' : ' items selected');
    }

    fetchFragment(bundleFragment).then(function () {
      root.querySelectorAll('.pcb__check').forEach(function (cb) {
        cb.addEventListener('change', recalc);
      });
      recalc();
    });

    var addBtn = root.querySelector('[data-role="bundle-add"]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [{ id: getMainVariantId(root), quantity: 1 }];
        root.querySelectorAll('.pcb__check').forEach(function (cb) {
          if (cb.checked) {
            items.push({ id: parseInt(cb.getAttribute('data-variant-id'), 10), quantity: 1 });
          }
        });

        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding…';

        var cartComponent = document.querySelector('cart-items-component[data-section-id]');
        var cartSectionId = cartComponent && cartComponent.getAttribute('data-section-id');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: cartSectionId || undefined }),
        })
          .then(function (response) {
            return response.json().then(function (body) {
              if (!response.ok) throw new Error(body.description || 'Could not add to cart');
              return body;
            });
          })
          .then(function (body) {
            addBtn.textContent = 'Added to Cart';
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { sections: body.sections } }));
            window.setTimeout(function () {
              addBtn.disabled = false;
              addBtn.textContent = originalText;
            }, 1800);
          })
          .catch(function (error) {
            addBtn.disabled = false;
            addBtn.textContent = 'Try again';
            window.setTimeout(function () {
              addBtn.textContent = originalText;
            }, 1800);
            console.error('[fixplus] bundle add to cart failed:', error.message);
          });
      });
    }
  }

  function getMainVariantId(root) {
    var pms = document.querySelector('.pms[data-product-id="' + root.getAttribute('data-product-id') + '"]');
    var input = pms ? pms.querySelector('[data-role="variant-id-input"]') : null;
    return input ? parseInt(input.value, 10) : null;
  }

  document.querySelectorAll('.pcx').forEach(function (root) {
    initBundle(root);

    var relatedFragment = root.querySelector('[data-role="related-fragment"]');
    if (relatedFragment) fetchFragment(relatedFragment);
  });

  // Catalog mode has no bundle/cart section — just the related-products grid.
  document.querySelectorAll('.pcxc').forEach(function (root) {
    var relatedFragment = root.querySelector('[data-role="related-fragment"]');
    if (relatedFragment) fetchFragment(relatedFragment);
  });
})();
